import { SITE_LOG,RMTICKET_LOG,COMPLAINT_LOG } from "./type";

const initialState = {
  siteLog: {},
  rmTicketLog: {},
  complaintLog: {},
};

const siteLogReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SITE_LOG:
      return {
        ...state,
        siteLog: payload,
      };
    case RMTICKET_LOG:
      return {
        ...state,
        rmTicketLog: payload,
      };
    case COMPLAINT_LOG:
      return {
        ...state,
        complaintLog: payload,
      }; 
    default:
      return {
        ...state,
      };
  }
};

export default siteLogReducer;
